import Issue from '@diziner/Issue';
import Logger from '@diziner/Logger';
import { InvalidArgumentException } from '@diziner/Exceptions/InvalidArgumentException';
import { Settings } from '@diziner/Settings';
import GoogleAnalytics from '@diziner/Analytics/GoogleAnalytics';
import NavigationMenu from '@diziner/NavigationMenu';
import { Events } from '@diziner/Events';
import Detectors from '@diziner/Utils/Detectors';
export class Diziner {
    constructor() {
        Diziner._instance = this;
        Logger.instance.debug('Diziner constructed');
        Settings.instance.updateSettingsFromGlobal().then(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window['GoA'] = new GoogleAnalytics(Settings.instance.googleAnalyticsCode);
        });
        document.querySelector('html')?.classList.remove('no-js');
        Events.Issue.UpdatePageIndex.subscribe(NavigationMenu.updateCurrentPageNumber);
        if (Detectors.isInternetExplorer()) {
            document.querySelector('html')?.classList.add('is-internet-explorer');
        }
    }
    static get instance() {
        return this._instance;
    }
    get issue() {
        return this._issue;
    }
    set issue(value) {
        this._issue = value;
        Logger.instance.debug('Diziner.issue set to Issue: ' + value.issueId);
    }
    loadIssue(issueId) {
        if (issueId === 0) {
            throw new InvalidArgumentException('Issue with ID 0 is invalid');
        }
        // TODO: APM Measure
        Logger.instance.time('Diziner.loadIssue');
        this.issue = (new Issue(issueId));
        this.issue.diziner = this;
        Logger.instance.timeEnd('Diziner.loadIssue');
    }
    /**
     * @param newUrl
     */
    changeUrl(newUrl) {
        Logger.instance.debug(self.name + '.changeUrl: ' + newUrl);
        document.querySelector('meta[property="og:url"]')?.
            setAttribute('content', newUrl);
        document.querySelector('meta[property="twitter:url"]')?.
            setAttribute('content', newUrl);
        const shareButtons = document.getElementById('share-buttons');
        if (shareButtons) {
            shareButtons.querySelector('a.linkedin')?.
                setAttribute('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + newUrl);
            shareButtons.querySelector('a.twitter')?.
                setAttribute('href', 'https://twitter.com/intent/tweet?url=' + newUrl + '&amp;text=' +
                window.encodeURIComponent(document.title));
            shareButtons.querySelector('a.google')?.
                setAttribute('href', 'https://plus.google.com/share?url=' + newUrl);
            shareButtons.querySelector('a.whatsapp')?.
                setAttribute('href', 'whatsapp://send?text=' + encodeURIComponent(newUrl));
            shareButtons.querySelector('a.email')?.
                setAttribute('href', 'mailto:?Subject=' + encodeURIComponent(document.title) +
                '&Body=' +
                encodeURIComponent(document.title + ' - ' + newUrl));
        }
    }
    /**
     * @param newTitle
     */
    async changeTitle(newTitle) {
        window.document.title = newTitle;
    }
    /**
     * @todo: Implement function
     * @param newTitle
     */
    async changeSharingTitle(newTitle) {
        document.querySelector('meta[name="title"]')?.
            setAttribute('content', newTitle);
        document.querySelector('meta[property="twitter:title"]')?.
            setAttribute('content', newTitle);
        document.querySelector('meta[property="og:title"]')?.
            setAttribute('content', newTitle);
    }
}
export default Diziner;
